module.exports = __webpack_public_path__ + "static/media/forGirl.6f60e0b8.png";